<template>
  <Multiselect
      v-model="selected"
      :options="options"
      :searchable="true"
      :loading="isLoading"
      :placeholder="placeholder + ' (Enter)'"
      :track-by="trackBy"
      :label="labelKey"
      :class="customClass"
      :filterResults="false"
      ref="multiselect"
      @search-change="onSearchChange"
      @keydown="handleKeyDown"
  />
</template>

<script>
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'

export default {
  name: 'SearchSelect',
  components: {
    Multiselect,
  },
  props: {
    value: null,
    url: { type: String, required: true },
    filterParams: { type: Object, default: () => ({}) },
    extractOptions: {
      type: Function,
      default: (data) => Array.isArray(data?.data) ? data.data : [],
    },
    placeholder: { type: String, default: 'Select...' },
    labelKey: { type: String, default: 'name' },
    trackBy: { type: String, default: 'id' },
    clearAll: { type: Boolean, default: false },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  data() {
    return {
      options: [],
      // selected: this.value,
      selected: null,
      isLoading: false,
      searchTerm: '',
    }
  },
  watch: {
    clearAll(val) {
      this.clearSelection()
    },
    value: {
      immediate: true,
      handler(val) {
      }
    },
    selected(val) {
      this.$emit('input', val)
      this.$emit('selectedFullObj', this.options.find((item) => item[this.trackBy] === val))
    },
  },
  methods: {
    clearSelection() {
      this.$refs.multiselect?.clear()
      this.searchTerm = ''
      this.options = []
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        // Prevent the default Multiselect behavior of selecting an option
        event.preventDefault();
        event.stopPropagation();

        // Trigger search instead
        const term = this.searchTerm?.trim();
        if (term && term.length >= 2) {
          this.fetchOptions(term);
        }
      }
    },
    onSearchChange(val) {
      this.searchTerm = val;
    },
    fetchOptions(searchTerm) {
      this.isLoading = true
      const payload = { ...this.filterParams, search: searchTerm }

      this.makeRequest('post', this.url, payload, {}, false, true, [205])
          .then((callResponse) => {
            this.isLoading = false
            const responseData = callResponse.response?.data || {}

            const code = responseData.code

            this.$refs.multiselect.clear()

            const extracted = this.extractOptions(responseData)

            this.options = ((code === 200)
                ? (Array.isArray(extracted) ? extracted : [extracted])
                : []).map(item => ({
              ...item,
              value: item[this.trackBy],
              [this.labelKey]: item[this.labelKey]
            }));

            this.$refs.multiselect.open()

          })
          .catch(() => {
            this.isLoading = false
          })
    },
  },
}
</script>
